var update = require("!../node_modules/style-loader/lib/addStyleUrl.js")(
  require("!!../node_modules/file-loader/dist/cjs.js?name=css/[name].[ext]!./nim.css")
, {"sourceMap":false,"hmr":true});
if(module.hot) {
  module.hot.accept("!!../node_modules/file-loader/dist/cjs.js?name=css/[name].[ext]!./nim.css", function() {
    update(require("!!../node_modules/file-loader/dist/cjs.js?name=css/[name].[ext]!./nim.css"));
  });

  module.hot.dispose(function() { update(); });
}